/**
 * 部件坐标上下文（T07）。
 *
 * `layout` 统一用页面局部坐标（便于直接进组件清单），渲染时需要知道
 * 父容器在页面坐标下的原点才能算出相对定位值 —— 该原点由本上下文向下传递。
 */
import { createContext, useContext } from 'react';

export interface FramedOrigin {
  x: number;
  y: number;
}

/** 默认原点 = 内容区左上角（页面局部坐标 0,0）。 */
export const FramedOriginContext = createContext<FramedOrigin>({ x: 0, y: 0 });

export function useFramedOrigin(): FramedOrigin {
  return useContext(FramedOriginContext);
}